import { Context } from '#store/overmind';
import { deleteCookie, hasCookie } from 'cookies-next';
import { getSession, signIn, signOut } from 'next-auth/react';
import { User } from 'next-auth';
import { tagCustomer } from '#utils/tagging/tag/tagCustomer';

export const initSession = async ({ state, actions }: Context) => {
  const userIsAuthenticated = hasCookie('next-auth.authenticated');
  if (
    (userIsAuthenticated && !state.user.profile) ||
    (!userIsAuthenticated && state.user.profile)
  ) {
    const session = await getSession();

    //handle token rotation error:
    //https://next-auth.js.org/tutorials/refresh-token-rotation
    if (session?.error === 'RefreshAccessTokenError') {
      sessionStorage.removeItem('user');
      await signIn('cidaas'); // Force sign in to resolve the error
    }

    if (!session?.user) {
      state.session.initialized = true;
      state.user.isLoggedIn = false;
      return;
    } else {
      state.session.sessionState = session.sessionState;
      state.session.token = session.accessToken;
      state.session.expires = session.expires;

      sessionStorage.setItem(
        'user',
        JSON.stringify({
          sessionState: session.sessionState,
          token: session.accessToken,
          expires: session.expires,
        })
      );

      const sessionUser = session.user as User;

      if (sessionUser.id) {
        tagCustomer(sessionUser.id);
        localStorage.setItem('magicId', sessionUser.id);
      }
      state.user.isLoggedIn = true;
      state.session.initialized = true;
      actions.user.loadUser();
    }
  } else {
    state.session.initialized = true;
  }
};

export const deleteSession = async ({ state }: Context) => {
  await signOut({ redirect: false });
  state.session.sessionState = null;
  state.session.token = null;
  state.session.expires = null;
  deleteCookie('next-auth.authenticated');
  sessionStorage.removeItem('user');
  localStorage.removeItem('magicId');
};
